import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import SEO from '../../components/SEO';
import heroImage from '../../assets/wood-hero.png';

const WoodPainting = () => {
    return (
        <div className="min-h-screen pb-20">
            <SEO 
                title="Wood Painting & Polishing Madurai" 
                description="Professional wood polishing and painting services in Madurai. Bring back the shine to your furniture." 
            />
            
            {/* Hero Section */}
            <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img src={heroImage} alt="Wood Polishing" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-blue-900/70"></div>
                </div>
                <div className="relative z-10 text-center px-4">
                    <motion.h1 
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="text-4xl md:text-6xl font-bold text-white mb-4"
                    >
                        Wood Painting & Polishing
                    </motion.h1>
                    <motion.p 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3 }}
                        className="text-xl text-blue-100 italic"
                    >
                        "Revealing the natural beauty of wood."
                    </motion.p>
                </div>
            </section>

            <div className="max-w-4xl mx-auto px-4 mt-20">
                <motion.div 
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="bg-white p-10 rounded-[2rem] shadow-xl border border-slate-100 mb-16"
                >
                    <h2 className="text-3xl font-bold text-blue-900 mb-6">Premium Finishes for Your Furniture</h2>
                    <p className="text-gray-600 mb-10 leading-relaxed text-lg text-center md:text-left">
                        Whether it's your main door, dining table, or cabinets, our wood polishing experts in Madurai bring back the luxury and shine. We specialize in various types of finishes including PU Polish, Melamine, and traditional Hand Polish.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {[
                            { title: "Wood Polishing", desc: "Premium PU and Melamine finishes for a glass-like or matte look that lasts for decades." },
                            { title: "Wood Painting", desc: "Transform old wooden frames and furniture with high-quality enamel or opaque wood paints." }
                        ].map((item, i) => (
                            <motion.div 
                                key={i}
                                whileHover={{ y: -10 }}
                                className="p-8 bg-slate-50 border border-slate-100 rounded-[2rem] hover:shadow-lg transition-all"
                            >
                                <Sparkles className="text-orange-600 mb-6" size={32} />
                                <h3 className="text-xl font-bold text-blue-900 mb-3">{item.title}</h3>
                                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                <motion.div 
                     initial={{ opacity: 0, scale: 0.95 }}
                     whileInView={{ opacity: 1, scale: 1 }}
                     viewport={{ once: true }}
                     className="bg-orange-600 text-white p-12 rounded-[3rem] text-center shadow-2xl"
                >
                    <h3 className="text-3xl font-bold mb-6 font-display">Restore Your Woodwork Today</h3>
                    <p className="text-orange-50 mb-10 text-xl max-w-2xl mx-auto">Don't let your expensive furniture fade away. Our experts can restore it to its original glory.</p>
                    <motion.a 
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        href="/contact" 
                        className="inline-block bg-blue-900 hover:bg-blue-800 text-white px-12 py-4 rounded-full font-bold text-lg transition-all shadow-xl"
                    >
                        Get a Free Quote
                    </motion.a>
                </motion.div>
            </div>
        </div>
    );
};

export default WoodPainting;
